export default "__VITE_ASSET__KDoH0yjy__"